import { FormControl, Grid, Radio, RadioGroup } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { ErrorMessage, Form, Formik } from "formik";
import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import ActionButton from "../../component/ActionButton";
import DateRangeCtrl from "../../component/DateRangePicker";
import Field from "../../component/Field";
import Label from "../../component/Label";
import SelectField from "../../component/SelectField";
import Toaster from "../../component/Toaster";
import CheckMultiSelectField from "../../component/checkMultiSelectField";
import { promoCodeAction } from "../../store/promoCode/promoCodeSlice";
import "./PromoCode.scss";
import { CommonUtil, FormValidation } from "../../util/Utils";
import { CommonService } from "../../store/common/CommonSlice";
import { DateTimeUtil } from "../../util/DateTimeUtils";

interface drawer {
  handleClose?: any;
  promoCodeSingleData?: any;
  userAction?: string;
  getPromoCodeList?: any;
}

const CreatePromoCode = (props: drawer) => {
  const { handleClose, userAction, promoCodeSingleData, getPromoCodeList } =
    props;
  const { t } = useTranslation();

  const [courseNameOption, setCourseNameOption] = useState<any>([]);
  const [franchiseeGroupOption, setFranchiseeGroupOption] = useState<any>([]);
  const [countryOption, setCountryOption] = useState<any>([]);
  const [regionsOption, setRegionsOption] = useState<any>([]);
  const [statesOption, setStatesOption] = useState<any>([]);
  const [areasOption, setAreasOption] = useState<any>([]);
  const [selectedRegion, setSelectedRegion] = useState<any>({});
  // const [selectedState, setSelectedState] = useState<any>({});
  const [allArea, setAllArea] = useState<any>([]);
  const [
    isRegistrationKitDiscountTypePercentage,
    setisRegistrationKitDiscountTypePercentage,
  ] = useState(false);
  const [
    isTuitionFeeDiscountTypePercentage,
    setisTuitionFeeDiscountTypePercentage,
  ] = useState(false);

  const dispatch = useDispatch<any>();

  type initialType = {
    promoCode: string;
    promoCodeDescription?: string;
    registrationKitDiscountType?: any;
    registrationKitDiscount?: any;
    tuitionFeeDiscountType?: any;
    tuitionFeeDiscount?: any;
    effectiveFromDate?: string;
    effectiveToDate?: string;
    active: string;
    courseId: any;
    franchiseeGroupId?: string;
    countryId?: string;
    effectiveDateRange?: any;
    regionIds?: [];
    stateIds?: [];
    areaIds?: [];
  };

  const [initialValue, setInitialValue] = useState({
    promoCode: "",
    promoCodeDescription: "",
    registrationKitDiscountType: "Amount",
    registrationKitDiscount: "",
    tuitionFeeDiscountType: "Amount",
    tuitionFeeDiscount: "",
    effectiveFromDate: "",
    effectiveToDate: "",
    active: "true",
    courseId: courseNameOption[0]?.value,
    franchiseeGroupId: "",
    countryId: countryOption[0]?.value,
    effectiveDateRange: null,
    regionIds: [] as [],
    stateIds: [] as [],
    areaIds: [] as [],
  });

  const getCourseNameOption = () => {
    dispatch(CommonService({ apiAction: "Course" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          // if (!userAction) {
          //   setTimeout(() => {
          //     setInitialValue({
          //       ...initialValue,
          //       courseId: result?.payload?.data?.data[0]?.id,
          //     });
          //   }, 1000);
          // }

          setCourseNameOption(
            result?.payload?.data?.data?.map((item: any) => {
              return { label: item.courseName, value: item.id };
            })
          );
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  const getFranchiseeGroupOption = () => {
    dispatch(promoCodeAction({ apiAction: "franchisee_group" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setFranchiseeGroupOption(
            result?.payload?.data?.data?.map((item: any) => {
              return { label: item.groupName, value: item.id };
            })
          );
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  const getCountryOption = () => {
    dispatch(CommonService({ apiAction: "Country" }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          // if (!userAction) {
          //   setTimeout(() => {
          //     setInitialValue({
          //       ...initialValue,
          //       countryId: result?.payload?.data?.data[0]?.id,
          //     });
          //   }, 500);
          // }

          setCountryOption(
            result?.payload?.data?.data?.map((item: any) => {
              return { label: item.countryName, value: item.id };
            })
          );

          getRegionsOption(result?.payload?.data?.data[0]?.id);
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  const getRegionsOption = (value: any) => {
    dispatch(promoCodeAction({ apiAction: "region", countryIds: value }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          setRegionsOption(
            result?.payload?.data?.data?.map((item: any) => {
              return { label: item.regionDisplayName, value: item.id };
            })
          );
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  const getStatesOption = (props: any) => {
    const { setFieldValue, values } = props;
    // Function to create query parameters from dynamic values
    function getQueryParameters(regionIds: any[], countryIds: any) {
      const params: string[] = [];
      if (regionIds.length > 0) {
        regionIds.forEach((regionId: any) => {
          params.push(`regionIds=${regionId}`);
        });
      }
      if (countryIds) {
        params.push(`countryIds=${countryIds}`);
      }
      return params.join("&");
    }
    dispatch(
      promoCodeAction({
        apiAction: "state",
        api: getQueryParameters(props.valuesRegionIds, props.valuesCountryId),
      })
    )
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          const statesData = result?.payload?.data?.data;
          const statesOption = CommonUtil.formateDropdownList(
            statesData,
            "stateDisplayName"
          );

          const filterStatesByRegion = (regionIds: any) => {
            const statesByRegion: any = {};
            regionIds.forEach((regionId: any) => {
              statesByRegion[regionId] = [];
              statesData.forEach((state: any) => {
                if (state.regionId === regionId) {
                  statesByRegion[regionId].push({
                    id: state.id,
                    stateName: state.stateName,
                  });
                }
              });
            });
            return statesByRegion;
          };

          setSelectedRegion(filterStatesByRegion(props.valuesRegionIds));
          const selectedStateIds =
            props.valuesRegionIds.length > 0
              ? statesOption
                  .filter((state: any) =>
                    props.values?.stateIds.includes(state.value)
                  )
                  .map((state: any) => state.value)
              : [];
          setStatesOption(statesOption);
          if (props.setFieldValue && props.values)
            getAreasOption(selectedStateIds, { setFieldValue, values });
          props.setFieldValue &&
            props.setFieldValue("stateIds", selectedStateIds);
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  const filterAreaByStates = (stateIds: any) => {
    const areaByStates: any = {};

    stateIds.length > 0 &&
      stateIds.forEach((stateId: any) => {
        areaByStates[stateId] = [];
        allArea.forEach((state: any) => {
          if (state.stateId === stateId) {
            areaByStates[stateId].push({
              id: state.id,
              areaName: state.areaName,
            });
          }
        });
      });
    return areaByStates;
  };

  const getAreasOption = (value: any, props?: any) => {
    dispatch(CommonService({ apiAction: "Area", ids: value }))
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          const areasData = result?.payload?.data?.data;
          const areaOption = CommonUtil.formateDropdownList(
            areasData,
            "areaDisplayName"
          );
          setAllArea(areasData);
          setAreasOption(areaOption);
          const selectedAreaIds =
            value.length > 0
              ? areaOption
                  .filter((state: any) =>
                    props.values?.areaIds.includes(state.value)
                  )
                  .map((state: any) => state.value)
              : [];
          props &&
            props?.setFieldValue &&
            props.setFieldValue("areaIds", selectedAreaIds);
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  useEffect(() => {
    getCourseNameOption();
    getFranchiseeGroupOption();
    getCountryOption();
  }, []);

  useEffect(() => {
    if (!userAction) {
      setInitialValue({
        ...initialValue,
        countryId: countryOption[0]?.value,
        courseId: courseNameOption[0]?.value,
      });
    }
  }, [courseNameOption, countryOption]);

  const handleSubmit = (values: initialType, props: any) => {
    values.active = values.active ? "Yes" : "No";

    if ((values?.stateIds ?? [])?.length <= 0) {
      delete values.stateIds;
    }
    if ((values?.regionIds ?? [])?.length <= 0) {
      delete values.regionIds;
    }
    if ((values?.areaIds ?? [])?.length <= 0) {
      delete values.areaIds;
    }
    if (!values?.countryId) {
      delete values.countryId;
    }
    if (!values?.franchiseeGroupId) {
      delete values.franchiseeGroupId;
    }

    dispatch(
      promoCodeAction({
        apiAction: userAction === "edit" ? "update" : "create",
        formValues: values,
      })
    )
      .then((result: any) => {
        if (result?.payload?.status === 200) {
          Toaster.success(undefined, result?.payload?.data?.message);
          handleClose();
          getPromoCodeList();
          props.resetForm();
        } else {
          Toaster.error(undefined, result.payload);
        }
      })
      .catch((err: any) => {
        // This console for debug the app if any error occurred in DEV
        console.log(err);
      });
  };

  const handleRadioCtrlChange = (e: any, setFieldValue: any) => {
    if (e.target.name === "registrationKitDiscountType") {
      e.currentTarget.value === "Percentage"
        ? setisRegistrationKitDiscountTypePercentage(true)
        : setisRegistrationKitDiscountTypePercentage(false);
      setFieldValue("registrationKitDiscountType", e.currentTarget.value);
      setFieldValue("registrationKitDiscount", "");
    }
    if (e.target.name === "tuitionFeeDiscountType") {
      e.currentTarget.value === "Percentage"
        ? setisTuitionFeeDiscountTypePercentage(true)
        : setisTuitionFeeDiscountTypePercentage(false);
      setFieldValue("tuitionFeeDiscountType", e.currentTarget.value);
      setFieldValue("tuitionFeeDiscount", "");
    }
  };

  const setEditData = () => {
    if (promoCodeSingleData) {
      let promoCodeUpdateData = CommonUtil.copyObject(promoCodeSingleData);
      promoCodeUpdateData.active =
        promoCodeUpdateData.active === "Yes" ? true : false;

      if (
        promoCodeUpdateData.effectiveFromDate &&
        promoCodeUpdateData.effectiveToDate
      ) {
        promoCodeUpdateData.effectiveDateRange = [
          DateTimeUtil.format(
            promoCodeUpdateData.effectiveFromDate,
            "DD/MM/YYYY",
            true
          ),
          DateTimeUtil.format(
            promoCodeUpdateData.effectiveToDate,
            "DD/MM/YYYY",
            true
          ),
        ];
      }
      promoCodeUpdateData.registrationKitDiscount =
        promoCodeUpdateData.registrationKitDiscount === null
          ? ""
          : promoCodeUpdateData.registrationKitDiscount;
      promoCodeUpdateData.tuitionFeeDiscount =
        promoCodeUpdateData.tuitionFeeDiscount === null
          ? ""
          : promoCodeUpdateData.tuitionFeeDiscount;

      setisRegistrationKitDiscountTypePercentage(
        promoCodeUpdateData?.registrationKitDiscountType === "Percentage"
      );
      setisTuitionFeeDiscountTypePercentage(
        promoCodeUpdateData?.tuitionFeeDiscountType === "Percentage"
      );

      // promoCodeUpdateData.registrationKitDiscountType ||= "Amount";
      //promoCodeUpdateData.tuitionFeeDiscountType ||= "Amount";

      if (promoCodeUpdateData?.countryId && promoCodeUpdateData?.regionIds) {
        getStatesOption({
          valuesCountryId: promoCodeUpdateData?.countryId,
          valuesRegionIds: promoCodeUpdateData?.regionIds,
        });
      } else if (promoCodeUpdateData?.countryId) {
        getStatesOption({ valuesCountryId: promoCodeUpdateData?.countryId });
      } else if (promoCodeUpdateData?.regionIds) {
        getStatesOption({ valuesRegionIds: promoCodeUpdateData?.regionIds });
      }
      if (promoCodeUpdateData?.countryId) {
        getRegionsOption(promoCodeUpdateData?.countryId);
      }
      if (promoCodeUpdateData?.stateIds) {
        getAreasOption(promoCodeUpdateData?.stateIds);
      }

      setInitialValue(promoCodeUpdateData);
    }
  };

  useEffect(() => {
    setEditData();
  }, [promoCodeSingleData]);

  return (
    <div className="form-ele-gap ">
      <Formik
        initialValues={initialValue}
        onSubmit={handleSubmit}
        enableReinitialize={true}
        validationSchema={Yup.object().shape({
          promoCode: Yup.string()
            .required(t("promoCodeDetails.requiredValidation.promoCode"))
            .matches(
              FormValidation.getIdPattern(),
              `${t("promoCodeDetails.promoCode")} ${t("is")} ${t("incorrect")}`
            ),
          courseId: Yup.string().required(
            t("promoCodeDetails.requiredValidation.courseId")
          ),
          promoCodeDescription: Yup.string().max(
            255,
            t("promoCodeDetails.maxDescriptionLength")
          ),
          registrationKitDiscount: Yup.number()
            .required(
              t("promoCodeDetails.requiredValidation.registrationKitDiscount")
            )
            .test("registrationKitDiscount", "Invalid value", function (value) {
              if (isRegistrationKitDiscountTypePercentage) {
                return Yup.number()
                  .min(1, "Percentage must be greater than or equal to 1")
                  .max(100, "Percentage must be less than or equal to 100")
                  .isValidSync(value);
              } else {
                return Yup.number()
                  .min(1, "Value must be greater than or equal to 1")
                  .max(9999999, "Invalid value")
                  .isValidSync(value);
              }
            }),
          tuitionFeeDiscount: Yup.number()
            .required(
              t("promoCodeDetails.requiredValidation.tuitionFeeDiscount")
            )
            .test("tuitionFeeDiscount", "Invalid value", function (value) {
              if (isTuitionFeeDiscountTypePercentage) {
                return Yup.number()
                  .min(1, "Percentage must be greater than or equal to 1")
                  .max(100, "Percentage must be less than or equal to 100")
                  .isValidSync(value);
              } else {
                return Yup.number()
                  .min(1, "Value must be greater than or equal to 1")
                  .max(9999999, "Invalid value")
                  .isValidSync(value);
              }
            }),
        })}
        validate={(values: any) => {
          const errors: any = {};

          // not select error for state
          const keysNotInStateIds: any = Object.keys(selectedRegion).filter(
            (key) => {
              const idsInSelectedRegion = selectedRegion[key].map(
                (item: any) => item.id
              );
              return values.stateIds.every(
                (id: any) => !idsInSelectedRegion.includes(id)
              );
            }
          );
          const notSelectedRegionArea = regionsOption
            .filter((item: any) =>
              keysNotInStateIds?.includes(item.value.toString())
            )
            .map((item: any) => item.label);
          if (keysNotInStateIds.length > 0) {
            errors.stateIds = `Please select ${notSelectedRegionArea.join(
              ", "
            )} state`;
          }

          // not select error for area
          const selectedState = filterAreaByStates(values.stateIds);
          const keysNotInAreaIds: any = Object.keys(selectedState).filter(
            (key) => {
              const idsInSelectedState = selectedState[key].map(
                (item: any) => item.id
              );
              return values.areaIds.every(
                (id: any) => !idsInSelectedState.includes(id)
              );
            }
          );
          const notSelectedState = statesOption
            .filter((item: any) =>
              keysNotInAreaIds?.includes(item.value.toString())
            )
            .map((item: any) => item.label);
          if (keysNotInAreaIds.length > 0) {
            errors.areaIds = `Please select ${notSelectedState.join(
              ", "
            )} Areas`;
          }

          return errors;
        }}
      >
        {({
          values,
          handleChange,
          handleBlur,
          errors,
          touched,
          dirty,
          isValid,
          setFieldValue,
          resetForm,
          setFieldTouched,
        }: any) => {
          return (
            <Form>
              <Grid
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 2, lg: 2 }}
              >
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Label required title={t("promoCodeDetails.promoCode")} />
                  <Field
                    className="textFiled"
                    name="promoCode"
                    value={values.promoCode}
                    max={255}
                    onChange={handleChange}
                    placeholder={t("enterHere")}
                    onBlur={handleBlur}
                    helperText={<ErrorMessage name="promoCode" />}
                    error={errors.promoCode && touched.promoCode}
                  />
                  <div>
                    <div className="form-ele-gap">
                      <Label
                        title={t("promoCodeDetails.promoCodeDescription")}
                      />
                      <Field
                        className="textFiled"
                        name="promoCodeDescription"
                        type="textarea"
                        multiline
                        rows={2}
                        value={values.promoCodeDescription}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        helperText={
                          <ErrorMessage name="promoCodeDescription" />
                        }
                        error={
                          errors.promoCodeDescription &&
                          touched.promoCodeDescription
                        }
                        placeholder={t("enterHere")}
                      />
                    </div>
                    <div className="form-ele-gap">
                      <Label
                        required
                        title={t("promoCodeDetails.courseName")}
                      />
                      <SelectField
                        name="courseId"
                        value={values.courseId}
                        onChange={handleChange}
                        defaultValue={1}
                        inputProps={{ "aria-label": "Without label" }}
                        options={courseNameOption}
                      />
                    </div>
                    <div className="form-ele-gap">
                      <Label title={t("promoCodeDetails.franchiseeGroup")} />
                      <SelectField
                        name="franchiseeGroupId"
                        value={values.franchiseeGroupId || t("select")}
                        onChange={handleChange}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        options={franchiseeGroupOption}
                      />
                    </div>

                    <div className="form-ele-gap">
                      <Label title={t("promoCodeDetails.country")} />
                      <SelectField
                        name="countryId"
                        value={values.countryId || t("select")}
                        onChange={(e: any) => {
                          setFieldValue("countryId", e.target.value);
                          getStatesOption({
                            valuesCountryId: e.target.value,
                            valuesRegionIds: values.regionIds,
                          });
                          getRegionsOption(e.target.value);
                          setFieldValue("regionIds", []);
                          setFieldValue("stateIds", []);
                          setFieldValue("areaIds", []);
                        }}
                        displayEmpty
                        inputProps={{ "aria-label": "Without label" }}
                        options={countryOption}
                      />
                    </div>
                    <div className="form-ele-gap select-all">
                      <Label title={t("promoCodeDetails.selectRegions")} />
                      <CheckMultiSelectField
                        value={values.regionIds || t("select")}
                        placeholder={t("select")}
                        defaultValue={t("select")}
                        onChange={(e: any) => {
                          setFieldValue("regionIds", e.target.value);
                          setFieldTouched("regionIds", true);
                          getStatesOption({
                            valuesRegionIds: e.target.value,
                            valuesCountryId: values.countryId,
                            setFieldValue,
                            values,
                          });
                        }}
                        name="regionIds"
                        type="textarea"
                        fullWidth
                        options={regionsOption}
                      />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <div>
                    <div className="select-all autocomplete-form">
                      <Label
                        title={t("promoCodeDetails.selectStates")}
                        required={values?.regionIds?.length > 0 ? true : false}
                      />
                      <CheckMultiSelectField
                        value={values.stateIds || t("select")}
                        onChange={(e: any) => {
                          setFieldValue("stateIds", e.target.value);
                          setFieldTouched("stateIds", true);
                          getAreasOption(e.target.value, {
                            setFieldValue,
                            values,
                          });
                        }}
                        name="stateIds"
                        defaultValue={t("all")}
                        type="textarea"
                        fullWidth
                        options={statesOption}
                      />
                      {touched.stateIds && errors.stateIds && (
                        <span style={{ fontSize: "12px", color: "red" }}>
                          {errors?.stateIds}
                        </span>
                      )}
                    </div>
                    <div className="form-ele-gap select-all">
                      <Label
                        title={t("promoCodeDetails.selectAreas")}
                        required={values?.regionIds?.length > 0 ? true : false}
                      />
                      <CheckMultiSelectField
                        value={values.areaIds || t("select")}
                        onChange={(e: any) => {
                          setFieldTouched("areaIds", true);
                          setFieldValue("areaIds", e.target.value);
                        }}
                        name="areaIds"
                        type="textarea"
                        fullWidth
                        options={areasOption}
                      />
                      {touched.areaIds && errors.areaIds && (
                        <span style={{ fontSize: "12px", color: "red" }}>
                          {errors?.areaIds}
                        </span>
                      )}
                    </div>
                    <div className="form-ele-gap">
                      <div>
                        <Label
                          required={
                            values.registrationKitDiscountType ? true : false
                          }
                          title={t(
                            "promoCodeDetails.registrationKitDiscountType"
                          )}
                        />
                      </div>
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="registrationKitDiscountType"
                          onChange={(e: any) =>
                            handleRadioCtrlChange(e, setFieldValue)
                          }
                          value={values.registrationKitDiscountType}
                        >
                          <FormControlLabel
                            value="Amount"
                            control={<Radio />}
                            label={
                              <label>{t("promoCodeDetails.amount")}</label>
                            }
                          />
                          <FormControlLabel
                            value="Percentage"
                            control={<Radio />}
                            label={
                              <label>{t("promoCodeDetails.percentage")}</label>
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                    <div
                      className="inherit-number-field"
                      style={{ marginTop: "8px" }}
                    >
                      <Field
                        className="textFiled"
                        name="registrationKitDiscount"
                        iconType={
                          isRegistrationKitDiscountTypePercentage &&
                          "Percentage"
                        }
                        value={values.registrationKitDiscount}
                        onChange={(e: any) => {
                          const inputValue = e.target.value;
                          const floatValue = parseFloat(inputValue);

                          if (isRegistrationKitDiscountTypePercentage) {
                            if (floatValue >= 0 && floatValue <= 100) {
                              handleChange(e);
                            } else if (inputValue === "") {
                              setFieldValue(e.target.name, null);
                            }
                          } else if (inputValue <= 9999999) {
                            handleChange(e);
                          }
                        }}
                        onBlur={handleBlur}
                        placeholder={t("enterHere")}
                        helperText={
                          <ErrorMessage name="registrationKitDiscount" />
                        }
                        error={
                          errors.registrationKitDiscount &&
                          touched.registrationKitDiscount
                        }
                      />
                    </div>
                    <div style={{ marginTop: "44px" }}>
                      <div className="form-ele-gap">
                        <Label
                          required={
                            values.tuitionFeeDiscountType ? true : false
                          }
                          title={t("promoCodeDetails.TuitionFeeDiscount")}
                        />

                        <div>
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby="demo-row-radio-buttons-group-label"
                              name="tuitionFeeDiscountType"
                              value={values.tuitionFeeDiscountType}
                              onChange={(e: any) =>
                                handleRadioCtrlChange(e, setFieldValue)
                              }
                            >
                              <FormControlLabel
                                value="Amount"
                                control={<Radio />}
                                label={
                                  <label>{t("promoCodeDetails.amount")}</label>
                                }
                              />
                              <FormControlLabel
                                value="Percentage"
                                control={<Radio />}
                                label={
                                  <label>
                                    {t("promoCodeDetails.percentage")}
                                  </label>
                                }
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                      <div
                        className="inherit-number-field"
                        style={{ marginTop: "8px" }}
                      >
                        <Field
                          className="textFiled"
                          name="tuitionFeeDiscount"
                          iconType={
                            isTuitionFeeDiscountTypePercentage && "Percentage"
                          }
                          value={values.tuitionFeeDiscount}
                          onChange={(e: any) => {
                            const inputValue = e.target.value;
                            const floatValue = parseFloat(inputValue);

                            if (isTuitionFeeDiscountTypePercentage) {
                              if (floatValue >= 0 && floatValue <= 100) {
                                handleChange(e);
                              } else if (inputValue === "") {
                                setFieldValue(e.target.name, null);
                              }
                            } else if (inputValue < 9999999) {
                              handleChange(e);
                            }
                          }}
                          onBlur={handleBlur}
                          placeholder={t("enterHere")}
                          helperText={
                            <ErrorMessage name="tuitionFeeDiscount" />
                          }
                          error={
                            errors.tuitionFeeDiscount &&
                            touched.tuitionFeeDiscount
                          }
                        />
                      </div>
                    </div>
                    <div>
                      <div>
                        <label>
                          {t("promoCodeDetails.effectiveDateRange")}{" "}
                        </label>
                        <div
                          className="date-picker doubleDatePicker promocode-effect-dt-range"
                          style={{ marginTop: "0px" }}
                        >
                          <DateRangeCtrl
                            name="effectiveDateRange"
                            placement="bottomEnd"
                            value={values?.effectiveDateRange}
                            onChange={(e: any) => {
                              setFieldValue(
                                "effectiveFromDate",
                                moment(e[0]).format("DD/MM/YYYY")
                              );
                              setFieldValue(
                                "effectiveToDate",
                                moment(e[1]).format("DD/MM/YYYY")
                              );
                              setFieldValue("effectiveDateRange", e);
                            }}
                          />
                          <ErrorMessage name="effectiveFromDate" />
                          <ErrorMessage name="effectiveToDate" />
                        </div>
                      </div>
                      <div className="form-ele-gap ">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={values.active}
                              onChange={(e: any) =>
                                setFieldValue("active", e.target.checked)
                              }
                              name="active"
                              defaultChecked
                            />
                          }
                          label={<label>{t("active")}</label>}
                        />
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
              <div className="border-top padding-up-15 center-end flex-gap">
                <ActionButton
                  label={t("clear")}
                  onClick={() => {
                    resetForm();
                    if (userAction === "edit") {
                      setEditData();
                    } else {
                      setRegionsOption([]);
                      setStatesOption([]);
                      setAreasOption([]);
                      setAllArea([]);
                      setisRegistrationKitDiscountTypePercentage(false);
                      setisTuitionFeeDiscountTypePercentage(false);
                    }
                  }}
                  type="reset"
                  actionButtonStyle="outline"
                ></ActionButton>
                <ActionButton
                  label={userAction === "edit" ? t("Update") : t("submit")}
                  disabled={!dirty || !isValid}
                ></ActionButton>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default CreatePromoCode;
